import React from 'react'
import { useTranslation } from 'react-i18next'
import { Select, InputSelect } from '@lmc/ui-kit'
import { Divider } from 'antd'
import { Text, Heading } from '@lmc/ui-kit/src/general'
import styled from 'styled-components'
import { NAMESPACE } from 'locale'
import { incidentReportsConstants } from 'locale/incidentReports'
import { useGroupedCarersWithSelected } from 'hooks/useGroupedOptions'
import { getStatusOptions } from './utils'

interface UpdateActionsModalProps {
  selectedStatus: string
  selectedOwner: string
  onStatusChange: (status: string) => void
  onOwnerChange: (owner: string) => void
}

const UpdateActionsModal: React.FC<UpdateActionsModalProps> = ({
  selectedStatus,
  selectedOwner,
  onStatusChange,
  onOwnerChange,
}) => {
  const { t } = useTranslation(NAMESPACE.INCIDENT_REPORTS)
  const groupedCarerOptions = useGroupedCarersWithSelected({
    assignedUserId: selectedOwner,
  })

  const statusOptions = getStatusOptions(t)

  const handleStatusChange = (value: unknown) => {
    onStatusChange(value as string)
  }

  const handleOwnerChange = (value: unknown) => {
    onOwnerChange(value as string)
  }

  return (
    <Container>
      <Title level={2} weight="medium">
        {t(incidentReportsConstants.UPDATE_AN_ACTION)}
      </Title>

      <Divider />
      <FormContainer>
        <FormSection>
          <Label level={1} weight="medium">
            {t(incidentReportsConstants.UPDATE_STATUS)}:
          </Label>
          <StyledSelect
            placeholder="Select status"
            options={statusOptions}
            value={selectedStatus}
            onChange={handleStatusChange}
          />
        </FormSection>

        <FormSection>
          <Label level={1} weight="medium">
            {t(incidentReportsConstants.OWNER)}:
          </Label>
          <StyledInputSelect
            placeholder={t(incidentReportsConstants.UNASSIGNED)}
            groupedOptions={groupedCarerOptions}
            value={selectedOwner || undefined}
            onChange={handleOwnerChange}
            showSearch={true}
            hasClear={true}
            listHeight={200}
            virtual={true}
          />
        </FormSection>
      </FormContainer>
      <Divider />
    </Container>
  )
}

const Container = styled.div``

const Title = styled(Heading)`
  padding-bottom: 16px;
  color: ${({ theme }) => theme.color.neutral.color3};
`

const FormSection = styled.div`
  margin-bottom: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
`

const FormContainer = styled.div`
  margin: 40px 0;
`

const Label = styled(Text)`
  color: ${({ theme }) => theme.color.neutral.color4};
`

const StyledSelect = styled(Select)`
  width: 332px;

  .ant-select-selector {
    border-color: ${({ theme }) => theme.color.neutral.color5} !important;
  }

  .ant-select-arrow {
    color: ${({ theme }) => theme.color.neutral.color5} !important;
  }
`

const StyledInputSelect = styled(InputSelect)`
  width: 332px !important;
  min-width: 332px !important;


  .ant-select-selector {
    border-color: ${({ theme }) => theme.color.neutral.color5} !important;
  }
`

export default UpdateActionsModal
